module.exports = __webpack_public_path__ + "media/images/on-sale-6afe00c690efc80f2d142fd17dcedd26.png";